function Locked(message) {
  this.name = "Locked";
  this.message = message || "";
  this.stack = new Error().stack;
}
Locked.prototype = Object.create(Error.prototype);
Locked.prototype.constructor = Locked;

export default Locked;
